/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_Multideck_DescInputs */



/**
* | output |
* | --- |
* | "separate deck per round (Standard rank only)" |
*
* @param {Og_Cfg_Multideck_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_multideck_desc = /** @type {((inputs?: Og_Cfg_Multideck_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_Multideck_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("deck séparé par ronde (rang Standard uniquement)")
	if (locale === "es") return /** @type {LocalizedString} */ ("mazo distinto por ronda (solo rango Standard)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("deck separado por rodada (apenas rank Standard)")
	if (locale === "it") return /** @type {LocalizedString} */ ("mazzo separato per round (solo rank Standard)")
	return /** @type {LocalizedString} */ ("separate deck per round (Standard rank only)")
});